import { Bell, ExternalLink, Plus, Star, LogOut } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";

function Stars({ category }) {
  const n = parseInt((category || "").match(/\d+/)?.[0] || "0", 10);
  return (
    <div className="hidden sm:flex items-center gap-0.5 shrink-0" data-testid="topbar-stars" aria-label={category || ""}>
      {Array.from({ length: n }).map((_, i) => (
        <Star key={i} size={13} className="text-brand-gold fill-brand-gold" />
      ))}
    </div>
  );
}

export default function Topbar({ ccu, hotels, scope, onSelectHotel, onAddHotel, onMenu, user, onLogout, canSwitch }) {
  const ci = ccu?.canonical_identity;
  const initials = (user?.name || "D").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <header className="sticky top-0 z-20 bg-brand-cream/95 backdrop-blur border-b border-brand-gold/40">
      <div className="flex items-center gap-3 lg:gap-4 px-4 lg:px-8 py-3 lg:py-4">
        <button data-testid="menu-toggle" onClick={onMenu} aria-label="Menu" className="lg:hidden w-10 h-10 rounded-lg border border-brand-gold/40 flex items-center justify-center text-brand-green shrink-0">
          <span className="block w-4 border-t-2 border-current" style={{ boxShadow: "0 5px 0 currentColor, 0 -5px 0 currentColor" }} />
        </button>
        {ci?.hero_image && (
          <img src={ci.hero_image} alt={ci?.name || ""} data-testid="topbar-hotel-thumb"
            className="hidden sm:block w-11 h-11 rounded-lg object-cover border border-brand-gold/40 shrink-0" />
        )}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 min-w-0">
            {canSwitch && scope ? (
            <Select value={`${scope.tenant}::${scope.hotel}`} onValueChange={onSelectHotel}>
              <SelectTrigger data-testid="hotel-switcher" className="h-auto border-0 bg-transparent p-0 shadow-none focus:ring-0 gap-2 w-auto max-w-full [&>svg]:shrink-0">
                <h1 className="font-serif text-[18px] sm:text-[22px] leading-none text-brand-ink truncate min-w-0">
                  {ci?.name || "—"}
                </h1>
                <Stars category={ci?.category} />
              </SelectTrigger>
              <SelectContent>
                {hotels.map((h) => (
                  <SelectItem key={`${h.tenant}::${h.hotel}`} value={`${h.tenant}::${h.hotel}`} data-testid={`hotel-option-${h.hotel}`}>
                    {h.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            ) : (
              <div className="flex items-center gap-2 min-w-0" data-testid="hotel-title">
                <h1 className="font-serif text-[18px] sm:text-[22px] leading-none text-brand-ink truncate min-w-0">{ci?.name || (user?.role === "admin" ? "Amministrazione" : "—")}</h1>
                <Stars category={ci?.category} />
              </div>
            )}
          </div>
          <div className="flex items-center gap-1.5 mt-1 text-[13px] text-brand-muted">
            <span>{ci?.locality || ""}</span>
            {ci?.official_site && (
              <a data-testid="hotel-site-link" href={ci.official_site} target="_blank" rel="noreferrer" className="text-brand-gold hover:text-brand-orange">
                <ExternalLink size={13} />
              </a>
            )}
          </div>
        </div>

        <div className="ml-auto flex items-center gap-2 sm:gap-3 lg:gap-5 shrink-0">
          {onAddHotel && (
          <Button data-testid="add-hotel-btn" onClick={onAddHotel} variant="outline"
            className="h-9 rounded-full border-brand-green/30 text-brand-green hover:bg-brand-green hover:text-brand-cream text-[13px] font-semibold">
            <Plus size={15} className="sm:mr-1" /><span className="hidden sm:inline">Aggiungi hotel</span>
          </Button>
          )}
          <button className="relative hidden sm:block text-brand-ink/70 hover:text-brand-ink" data-testid="notif-bell">
            <Bell size={20} strokeWidth={1.75} />
            <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-brand-orange" />
          </button>
          <div className="flex items-center gap-2" data-testid="topbar-user">
            <div className="w-9 h-9 rounded-full bg-brand-green text-brand-cream flex items-center justify-center text-[12px] font-bold">{initials}</div>
            <div className="hidden xl:block">
              <div className="text-[13px] font-semibold text-brand-ink leading-none" data-testid="topbar-user-name">{user?.name || "Direttore"}</div>
              <div className="text-[11px] text-brand-muted mt-0.5">{{ admin: "Amministrazione", caporeparto: "Caporeparto", dipendente: "Reparto" }[user?.role] || "Direttore"}</div>
            </div>
            <button onClick={onLogout} aria-label="Esci" title="Esci" className="text-brand-muted hover:text-brand-maroon ml-1" data-testid="logout-btn"><LogOut size={17} /></button>
          </div>
          <div className="hidden 2xl:block pl-5 border-l border-brand-gold/40 text-right">
            <div className="text-[10.5px] font-bold tracking-[0.14em] text-brand-green leading-tight">
              OSPITI PIÙ SODDISFATTI<br />RISULTATI PIÙ GRANDI
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
